import {NgModule} from '@angular/core';
import {WalletAssociateFormComponent} from './associate/wallet-associate-form.component';
import {WalletFormComponent} from './form/wallet-form.component';
import {IntegrationRoutingRuleFormComponent} from './integration-routing-rule-form/integration-routing-rule-form.component';
import {IntegrationRoutingRulesComponent} from './integration-routing-rules/integration-routing-rules.component';
import {WalletViewComponent} from './view/wallet-view.component';

/**
 * Exports standalone wallet sub-components (used in dialogs).
 * GateweeWalletsComponent is declared in ComponentsV2Module so it has
 * access to GateweeContentPageComponent, GateweeTableV2Component, etc.
 */
@NgModule({
  imports: [
    WalletViewComponent,
    WalletFormComponent,
    WalletAssociateFormComponent,
    IntegrationRoutingRulesComponent,
    IntegrationRoutingRuleFormComponent,
  ],
  exports: [
    WalletViewComponent,
    WalletFormComponent,
    WalletAssociateFormComponent,
    IntegrationRoutingRulesComponent,
    IntegrationRoutingRuleFormComponent,
  ],
})
export class GateweeWalletsModule {}
